/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { Button } from 'react-bootstrap';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { useStyles } from './hooks/useStyles';
import FilterCategoriesTree from '../users/users/components/FilterNavigate';
import Preloader from '../../../components/ui/Preloader/Preloader';
import { SHeadTableCell } from '../../../components/styledComponents/Tables';
import { useFormatMessage } from '../../../hooks';
import homeStyles from '../homeStyles';
import { IAppState } from '../../../store/rootDuck';
import { getStatusColor } from '../../../utils/dynamicStatusColor';
import DeclineDialog from './components/DeclineDialog';
import { actions as balanceRequstAction } from '../../../store/ducks/balanceRequest.duck';
import TablePaginator from '../../../components/tableComponents/TablePaginator/TablePaginator';
import { useDecline } from './hooks/useDecline';
import { useApprove } from './hooks/useApprove';

export interface IStatusType {
  type: string;
  translate: string;
}

const BalanceRequestsPage: React.FC<TPropsFromRedux> = ({
  loading,
  fetch,
  data,
  page,
  size,
  total,
}) => {
  const classes = useStyles();
  const homeClasses = homeStyles();

  const fm = useFormatMessage();
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [decleneFetch, loadingDecline, successDecline] = useDecline()
  const [approveFetch, loadingApprove, successApprove] = useApprove()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleDeclineClick = (event: React.MouseEvent<HTMLButtonElement>, item: any) => {
    setSelectedItem(item);
    setAnchorEl(event.currentTarget);
  };

  const statustranslates: { [type: string]: string } = {
    CREATED: 'Pending',
    CANCELLED: 'Declined',
    COMPLETED: 'Approved',
  };

  const handleConfirmDecline = async () => {
    if (!selectedItem) return;

    setAnchorEl(null);
    const noteData = { note: '', reasonForUser: '' };
    decleneFetch(selectedItem.id, noteData)
  };

  useEffect(() => {
    fetch({ page, size });
  }, []);

  const onApprove = async (paymentId: string) => {
    const noteData = { note: '' };
    approveFetch(paymentId, noteData)
  };

   useEffect(()=> {
      if(successDecline || successApprove)
        { fetch({page, size});
      }
    },[ successDecline, successApprove ])

  const balanceData = data?.content;
  return (
    <div style={{ maxWidth: 1440, width: '100%', margin: '0 auto' }}>
      <Row>
        <Col>
          <div className={classes.container}>
            <div className={classes.filterColTopBalance}>
              <FilterCategoriesTree
                setSelectedCategoryId={setSelectedCategoryId}
                selectedCategoryId={selectedCategoryId}
              />
            </div>

            <div style={{ flex: 1, marginTop: '65px' }}>
              {loading ? (
                <div className={classes.preloaderContainer}>
                  <Preloader />
                </div>
              ) : !balanceData?.length ? (
                <Typography className={classes.empty} component='h5' variant='h5'>
                  {fm('COMMON.LIST.EMPTY')}
                </Typography>
              ) : (
                <Card className={classes.tableContainer}>
                  <CardContent className={homeClasses.tableContainer}>
                    <Table aria-label='simple table'>
                      <TableHead>
                        <TableRow>
                          <SHeadTableCell>{fm('USER.TABLE.FIO')}</SHeadTableCell>
                          <SHeadTableCell>{fm('USER.TABLE.EMAIL')}</SHeadTableCell>
                          <SHeadTableCell>Type</SHeadTableCell>
                          <SHeadTableCell>Amount</SHeadTableCell>
                          <SHeadTableCell>{fm('BODY.TABLE.STATUS')}</SHeadTableCell>
                          <SHeadTableCell align='right'>
                            {fm('USER.TABLE.ACTION')}
                          </SHeadTableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {balanceData?.map(item => (
                          <TableRow style={{ border: 'none' }} key={item.id}>
                            <TableCell className={classes.tableText}>
                              {item.userFullName}
                            </TableCell>

                            <TableCell className={classes.textEmail}>
                              {item.userFullName || '-'}
                            </TableCell>

                            <TableCell className={classes.tableText}>{item.type}</TableCell>

                            <TableCell className={classes.tableText}>
                              {`$ ${item.amount}`}
                            </TableCell>

                            <TableCell
                              className={classes.tableText}
                              style={{ color: getStatusColor(item.status) }}
                            >
                              {statustranslates[item.status]}
                            </TableCell>

                            <TableCell
                              style={{
                                border: 'none',
                                color: '#304497',
                                fontWeight: 400,
                                fontSize: 16,
                              }}
                              align='right'
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'flex-end',
                                  gap: 8,
                                }}
                              >
                                {item.status === 'CREATED' && (
                                  <>
                                    <Button
                                      style={{
                                        backgroundColor: '#F5F6F9',
                                        borderRadius: 12,
                                        width: 112,
                                        height: 35,
                                        color: '#1DA316',
                                        border: 'none',
                                        fontWeight: 600,
                                      }}
                                      onClick={() => onApprove(item.id)}
                                    >
                                      Approve
                                    </Button>

                                    <Button
                                      style={{
                                        backgroundColor: '#F5F6F9',
                                        borderRadius: 12,
                                        width: 112,
                                        height: 35,
                                        color: '#DC1F1F',
                                        border: 'none',
                                        fontWeight: 600,
                                      }}
                                      onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                                        handleDeclineClick(e, item)
                                      }
                                    >
                                      Decline
                                    </Button>
                                  </>
                                )}
                              </div>
                            </TableCell>
                            <DeclineDialog
                              anchorEl={anchorEl}
                              onClose={() => setAnchorEl(null)}
                              onConfirm={() => handleConfirmDecline()}
                            />
                          </TableRow>
                        ))}
                      </TableBody>

                      <TableFooter>
                        <TableRow style={{ border: 'none' }}>
                          <TablePaginator
                            page={page || 0}
                            realPerPage={20}
                            perPage={size}
                            total={total}
                            fetchRows={(data: any) => fetch({ ...data })}
                            label=''
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </CardContent>
                </Card>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

const connector = connect(
  (state: IAppState) => ({
    loading: state.balanceRequest.loading,
    data: state.balanceRequest.balanceData,
    completeSuccess: state.balanceRequest.postCompleteSuccessed,
    page: state.balanceRequest.page,
    size: state.balanceRequest.size,
    total: state.balanceRequest.total,
  }),
  {
    fetch: balanceRequstAction.fetchRequest,
    postComplete: balanceRequstAction.postCompleteRequest,
    postCancel: balanceRequstAction.postCancelRequest,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(BalanceRequestsPage);
